import { GetStyledCompImg } from 'common-modules/general/Modules/functions';
import styled from 'styled-components';

interface StyleProps {
  hover?: boolean;
}
export const HeertIcon = styled.span`
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  width: 1.5rem;
  height: 1.3125rem;
  margin: -0.625rem 0 0 -0.75rem;
  background: url(${GetStyledCompImg('common/ico_heart_off.png')}) no-repeat center top;
`;

export const ShareIcon = styled.span`
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 2;
  width: 1.25rem;
  height: 1.5rem;
  margin: -0.75rem 0 0 -0.625rem;
  background: url(${GetStyledCompImg('common/ico_share_off.png')}) no-repeat center top;
`;

export const DownIcon = styled.span`
  position: relative;
  top: 2px;
  display: inline-block;
  margin-right: 10px;
  margin-right: 0.625rem;
  width: 24px;
  width: 1.5rem;
  height: 18px;
  height: 1.125rem;
  background: url(${GetStyledCompImg('common/ico_download.png')}) no-repeat center top;
`;
export const AnswerIcon = styled.span`
  position: absolute;
  top: 2px;
  display: inline-block;
  margin-right: 10px;
  margin-right: 0.625rem;
  width: 24px;
  width: 1.5rem;
  height: 22px;
  height: 1.25rem;
  background: url(${GetStyledCompImg('common/ico_answer.png')}) no-repeat center;
  background-size: contain;
`;
export const PrintIcon = styled.i`
  width: 1.375rem;
  height: 1.4375rem;
  background: url(${GetStyledCompImg('common/ico_print.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const LoginIcon = styled.i`
  width: 1rem;
  height: 1.5rem;
  background: url(${GetStyledCompImg('common/ico_login.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const EmailIcon = styled.i`
  width: 1.375rem;
  height: 0.9375rem;
  background: url(${GetStyledCompImg('common/ico_email.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const LockIcon = styled.i`
  width: 1.125rem;
  height: 1.5rem;
  background: url(${GetStyledCompImg('common/ico_password02.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const BirthIcon = styled.i`
  width: 1.125rem;
  height: 1.5rem;
  background: url(${GetStyledCompImg('common/ico_birthday.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const PhoneIcon = styled.i`
  width: 1rem;
  height: 1.5rem;
  background: url(${GetStyledCompImg('common/ico_phone.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const PrevArrowIcon = styled.i`
  width: 0.5rem;
  height: 0.875rem;
  background: url(${GetStyledCompImg('common/ico_paginav_prev.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const PrevDoubleArrowIcon = styled.i`
  width: 0.875rem;
  height: 0.875rem;
  background: url(${GetStyledCompImg('common/ico_paginav_first.png')}) no-repeat 0 0;

  display: inline-block;
`;

export const NextArrowIcon = styled.i`
  width: 0.5rem;
  height: 0.875rem;
  background: url(${GetStyledCompImg('common/ico_paginav_next.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const ArrowLargeIcon = styled.i`
  width: 19px;
  width: 1.1875rem;
  height: 11px;
  height: 0.6875rem;
  background: url(${GetStyledCompImg('common/ico_up_arrow.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const NextDoubleArrowIcon = styled.i`
  width: 0.875rem;
  height: 0.875rem;
  background: url(${GetStyledCompImg('common/ico_paginav_last.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const CheckMoneyIcon = styled.span`
  width: 3rem;
  height: 3rem;
  background: ${(props: StyleProps) =>
    !props.hover
      ? `url(${GetStyledCompImg('common/ico_checkmoney_off.png')}) no-repeat 0 0`
      : `url(${GetStyledCompImg('common/ico_checkmoney_on.png')}) no-repeat 0 0`};
  display: inline-block;
  background-size: 48px 48px;
`;

export const CalendarIcon = styled.span`
  width: 3.9375rem;
  height: 3.5625rem;
  background: ${(props: StyleProps) =>
    !props.hover
      ? `url(${GetStyledCompImg('common/ico_calendar02_off.png')}) no-repeat 0 0`
      : `url(${GetStyledCompImg('common/ico_calendar02_on.png')}) no-repeat 0 0`};

  display: inline-block;
  background-size: 63px 57px;
`;

export const ToolIcon = styled.span`
  width: 3.1875rem;
  height: 3.1875rem;
  background: ${(props: StyleProps) =>
    !props.hover
      ? `url(${GetStyledCompImg('common/ico_tool_off.png')}) no-repeat 0 0`
      : `url(${GetStyledCompImg('common/ico_tool_on.png')}) no-repeat 0 0`};

  display: inline-block;
  background-size: 51px 51px;
`;
export const AddIcon = styled.i`
  width: 1.5rem;

  height: 1.5rem;
  background: url(${GetStyledCompImg('ico_plus_white.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 24px 24px;
`;

export const SearchIcon = styled.i`
  width: 1.5rem;

  height: 1.5rem;
  background: url(${GetStyledCompImg('common/ico_gnb_search.png')}) no-repeat 0 0;
  display: inline-block;
  background-size: 24px 24px;
`;
export const CloseIcon = styled.i`
  width: 1.25rem;
  height: 1.1875rem;
  background: url(${GetStyledCompImg('common/ico_close04.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const Star02Icon = styled.i`
  margin-left: 0.625rem;
  vertical-align: middle;
  width: 0.5625rem;
  height: 0.5625rem;
  position: relative;
  top: -0.2875rem;
  background: url(${GetStyledCompImg('common/ico_star02.png')}) no-repeat 0 0;
  display: inline-block;
`;

export const AddFileIcon = styled.i`
  margin-left: 0.625rem;
  vertical-align: -1px;
  width: 1rem;
  height: 1rem;
  position: relative;
  background-size: contain;
  display: inline-block;
  background: url(${GetStyledCompImg('common/ico_add_file.png')}) no-repeat 0 0;
`;
export const AttentionIcon01 = styled.i`
  width: 66px;
  width: 4.125rem;
  height: 53px;
  height: 3.3125rem;
  background: url(${GetStyledCompImg('common/ico_attention01.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const AttentionIcon02 = styled.i`
  width: 66px;
  width: 4.125rem;
  height: 53px;
  height: 3.3125rem;
  background: url(${GetStyledCompImg('common/ico_attention02.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const AttentionIcon03 = styled.i`
  width: 66px;
  width: 4.125rem;
  height: 53px;
  height: 3.3125rem;
  background: url(${GetStyledCompImg('common/ico_attention03.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const AttentionIcon04 = styled.i`
  width: 66px;
  width: 4.125rem;
  height: 53px;
  height: 3.3125rem;
  background: url(${GetStyledCompImg('common/ico_attention04.png')}) no-repeat 0 0;
  display: inline-block;
`;
export const NextIconLarge = styled.i`
  width: 19px;
  width: 1.1875rem;
  height: 11px;
  height: 1.5rem;
  vertical-align: bottom;
  background: url(${GetStyledCompImg('common/bu_arrow_black_right.png')}) no-repeat 0 0;
  display: inline-block;
  margin-left: 10px;
`;
